export default __webpack_public_path__ + "static/media/greenline-logo-white.47ab3db0.svg";